import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { AlertHandlerActions } from './partials/alert-handler'
import { AttachmentSharedActions } from './partials/attachments'
import { CachedDropdownsActions } from './partials/cached-dropdowns'
import { RouteSharedActions } from './partials/route'
import { SharedScrollableDropdownActions } from './partials/scrollable-dropdown'
import { SharedSettingsActions } from './partials/settings'
import { TmetricSharedActions } from './partials/tmetric'
import { WorkflowSharedActions } from './partials/workflow'
import { ZipCodesActions } from './partials/zipcodes'

export const SharedActions = {
  ...AlertHandlerActions,
  ...AttachmentSharedActions,
  ...CachedDropdownsActions,
  ...RouteSharedActions,
  ...SharedScrollableDropdownActions,
  ...SharedSettingsActions,
  ...TmetricSharedActions,
  ...WorkflowSharedActions,
  ...ZipCodesActions,

  getOptions: async (_, requestData) => {
    // generic method for getting drop-down options
    return axiosRequest.
      get(`/options/${requestData.model}/${requestData.field}`).
      then(({ data }) => {
        return data.options || []
      }).
      catch(handleError)
  },
}
